import { generatePath, Redirect, Route, Switch, useLocation, useParams } from 'react-router-dom';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import Lesson from './routes/Lesson';
import Homepage from './routes/Homepage';

// @ts-expect-error Could not find a declaration file for module
import TrackPageRouter from './containers/TrackPage/TrackPageRouter';
import Catalog from './routes/Catalog';
import { RESULTS_URL_FRAGMENT, TRACKS_URL_FRAGMENT, PARTNER_TRACKS_URL_FRAGMENT, WIZARD_URL_FRAGMENT, LEGACY_WATCH_LATER_URL_FRAGMENT, WATCH_LATER_URL_FRAGMENT, MY_PLAYLISTS_URL_FRAGMENT, SAVED_ITEMS_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT, PLAYLIST_RESULTS_URL_FRAGMENT, PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT, ASSIGN_PLAYLIST_URL_FRAGMENT, LEGACY_AWARD_URL_FRAGMENT, LEGACY_SHARE_AWARD_URL_FRAGMENT, AWARD_URL_FRAGMENT, SHARE_AWARD_URL_FRAGMENT, SHARE_AWARD_PREVIEW_URL_FRAGMENT, SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS, HUBSPOT_PLAYLISTS_ADMIN_URL_FRAGMENT, MY_TEAM_URL_FRAGMENT, PROFILE_URL_FRAGMENT, LEGACY_MYLEARNING_URL_FRAGMENT, MY_TEAM_CERTIFICATIONS_URL_FRAGMENT, MY_TEAM_MEMBERS_URL_FRAGMENT, PRACTICE_MODE_URL_FRAGMENT, LESSONS_URL_FRAGMENT, SHORT_URL_FRAGMENT, MYLEARNING_URL_FRAGMENT } from './constants/Navigation';
// @ts-expect-error Could not find a declaration file for module
import TrackAwardModalContainer from './containers/TracksPage/TrackAwardModalContainer';
// @ts-expect-error Could not find a declaration file for module
import EngagementTracking from './EngagementTracking';
import NewUserLanding from './components/Landing/NewUserLanding';
import AchievementPreviewModal from './components/Modals/AchievementPreviewModal';
import { HUBSPOT_SOFTWARE_INDEX } from './features/wizard';
import AwardShareControls from './components/AwardShareControls';
import MyPlaylists from './routes/MyPlaylists';
import Playlist from './routes/Playlist';
import enviro from 'enviro';
import { useShowDevtools } from './features/devtools/devtoolsQueries';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import AssignPlaylist from './routes/AssignPlaylist';
import { MY_PLAYLISTS_TABS } from './features/myPlaylists';
import { ShortContentRoute } from './routes/ShortContent';
import { MyLearningTabs } from './features/myLearning';
import { getOverviewModalParams } from 'academy-common-lib/utils/url';
import { SoftwareDiscoveryIframe } from './features/toolRecommendations';
import Wizard from './routes/Wizard';
import HubspotPlaylistsAdmin from './features/hubspotPlaylists/components/hubspotPlaylistsAdmin/HubspotPlaylistsAdminMainPage';
import MyTeamOverview from './features/myTeam/routes/MyTeamOverview';
import MyTeamCertificationsIndex from './features/myTeam/routes/MyTeamCertificationsIndex';
import MyTeamMembers from './features/myTeam/routes/MyTeamMembers';
import { MyProfile, UserProfile, EditProfile } from './routes/Profile';
import MyTeamCertificationProfile, { RedirectToCertificationProfileDefaultTab } from './features/myTeam/routes/MyTeamCertificationProfile';
import MyTeamCertificationsByTeam, { RedirectToCertificationsByTeamDefaultTab } from './features/myTeam/routes/MyTeamCertificationsByTeam';
import MyTeamPlaylists, { RedirectToPlaylistsDefaultTab } from './features/myTeam/routes/MyTeamPlaylists';
import ReactRouterScrollToTop from 'academy-common-lib/components/routing/ReactRouterScrollToTop';
import WatchLater from './routes/WatchLater';
import { RedirectToMyTeamOverview } from './features/myTeam/routes/MyTeamOverview';
import { LEGACY_MY_TEAM_URL_FRAGMENT } from './features/myTeam/constants/routes';
import { PracticeMode } from './features/practiceMode/PracticeMode';
import { NavPageRoute } from './features/navigation/components/NavPageRoute';
import { ModalRoute } from './features/navigation/components/ModalRoute';
import { RedirectToMyLearning } from './features/myLearning/myLearningRouting';
import ReactRouterSmoothScrollToTop from 'academy-common-lib/components/routing/ReactRouterSmoothScrollToTop';
import NotFound from './routes/NotFound';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RedirectToTracksWithQueryParams = () => {
  const location = useLocation();
  const {
    pathname,
    search
  } = location;
  if (/cat=|tools=|awardType=|level=|duration=|contentType=|language=/i.test(search)) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: Object.assign({}, location, {
        pathname: RESULTS_URL_FRAGMENT
      })
    });
  }
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace('/tracks', '')
    })
  });
};
const RedirectToAward = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  const {
    trackId,
    awardName
  } = useParams();
  const legacyPath = generatePath(LEGACY_AWARD_URL_FRAGMENT, {
    trackId,
    awardName
  });
  const newPath = generatePath(AWARD_URL_FRAGMENT, {
    trackId
  });
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace(legacyPath, newPath)
    })
  });
};
const RedirectToAwardShare = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  const {
    trackId,
    awardName
  } = useParams();
  const legacyPath = generatePath(LEGACY_SHARE_AWARD_URL_FRAGMENT, {
    trackId,
    awardName
  });
  const newPath = generatePath(SHARE_AWARD_URL_FRAGMENT, {
    trackId
  });
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace(legacyPath, newPath)
    })
  });
};
const RedirectToWatchLater = () => {
  const location = useLocation();
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: WATCH_LATER_URL_FRAGMENT
    })
  });
};
const LEGACY_OVERVIEW_URL = ':prefix(.*)/:type(course-overview|lesson-overview|short-overview)/:id/:source?/:language?';
const RedirectToNewOverview = () => {
  const location = useLocation();
  const {
    prefix,
    type,
    id,
    source,
    language
  } = useParams();
  const search = new URLSearchParams(location.search);
  const newParams = getOverviewModalParams({
    id: Number(id),
    type: type === 'course-overview' ? 'TRACK' : type === 'lesson-overview' ? 'LESSON' : 'SHORT_FORM_CONTENT',
    language,
    source
  });
  Object.entries(newParams).forEach(([key, value]) => {
    search.set(key, value);
  });
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: prefix,
      search: `?${search}`
    })
  });
};
const PartnerPage = Loadable({
  loader: () => import( /* webpackChunkName: "bundles/partners" */
  './routes/Partners').then(mod => mod.default)
});
const QaOnlyRoutes = Loadable({
  loader: () => import( /* webpackChunkName: "bundles/qaOnly" */'./components/QaOnly/QaOnlyRoutes').then(mod => mod.default)
});
const Devtools = Loadable({
  loader: () => import( /* webpackChunkName: "bundles/devtools" */'./features/devtools').then(mod => mod.Devtools),
  LoadingComponent: () => null
});
const RemoveTrailingSlash = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: pathname.replace(/\/+$/, '')
    })
  });
};
const LegacyWatchLaterRoutePaths = [`${LEGACY_WATCH_LATER_URL_FRAGMENT}/page/:page`, LEGACY_WATCH_LATER_URL_FRAGMENT];
const myPlaylistsTabs = MY_PLAYLISTS_TABS.join('|');
export const MyPlaylistsRoutePaths = [`${MY_PLAYLISTS_URL_FRAGMENT}/:tab(${myPlaylistsTabs})/page/:page`, `${MY_PLAYLISTS_URL_FRAGMENT}/page/:page`, `${MY_PLAYLISTS_URL_FRAGMENT}/:tab(${myPlaylistsTabs})?`];
export const WizardRoutePaths = [`${WIZARD_URL_FRAGMENT}/${HUBSPOT_SOFTWARE_INDEX}/:categoryGroup/:certsOnly(true|false)`, `${WIZARD_URL_FRAGMENT}/${HUBSPOT_SOFTWARE_INDEX}/:categoryGroup?/:category?/:certsOnly(true|false)?`, `${WIZARD_URL_FRAGMENT}/:categoryGroup/:certsOnly(true|false)`, `${WIZARD_URL_FRAGMENT}/:categoryGroup?/:category?/:certsOnly(true|false)?`];
export const Routes = () => {
  const showDevtools = useShowDevtools();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), showDevtools && /*#__PURE__*/_jsx(Devtools, {}), /*#__PURE__*/_jsx(NewUserLanding, {}), /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        component: RemoveTrailingSlash,
        path: "/*(/+)"
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: SoftwareDiscoveryIframe,
        pageTitleI18nKey: "learningCenter.pageTitles.softwareDiscovery",
        path: `/${SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS}/:toolSlug?`,
        shouldRenderFullScreen: true
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: PracticeMode,
        pageTitleI18nKey: "learningCenter.pageTitles.practiceMode",
        path: PRACTICE_MODE_URL_FRAGMENT,
        shouldRenderFullScreen: true
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: Wizard,
        pageTitleI18nKey: "learningCenter.pageTitles.findYourPath",
        path: WizardRoutePaths
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: TrackPageRouter,
        pageTitleI18nKey: "learningCenter.pageTitles.course",
        path: [`${TRACKS_URL_FRAGMENT}/:trackId(\\d+)/:lessonId?/:contentId?`],
        shouldRenderCenteredContent: false,
        shouldRenderCompactSearchBar: true,
        shouldRenderTabs: false
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: Lesson,
        pageTitleI18nKey: "learningCenter.pageTitles.lesson",
        path: "/lessons/:lessonId/:contentId?",
        shouldRenderCenteredContent: false,
        shouldRenderCompactSearchBar: true,
        shouldRenderTabs: false
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: AwardShareControls,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.shareAward",
        path: [SHARE_AWARD_URL_FRAGMENT, SHARE_AWARD_PREVIEW_URL_FRAGMENT],
        shouldRenderFullScreen: true
      }), /*#__PURE__*/_jsx(Route, {
        component: RedirectToAwardShare,
        path: LEGACY_SHARE_AWARD_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(Route, {
        component: RedirectToNewOverview,
        path: LEGACY_OVERVIEW_URL
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: Homepage,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.home",
        path: "/",
        shouldRenderCenteredContent: false,
        shouldRenderSearch: false
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: Catalog,
        pageTitleI18nKey: "learningCenter.pageTitles.browseCourses",
        path: RESULTS_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: PartnerPage,
        pageTitleI18nKey: "learningCenter.pageTitles.partnerCourses",
        path: PARTNER_TRACKS_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(Route, {
        component: RedirectToMyTeamOverview,
        exact: true,
        path: LEGACY_MY_TEAM_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: MyTeamOverview,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.myTeam",
        path: MY_TEAM_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: MyTeamCertificationsIndex,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.myTeamCertifications",
        path: MY_TEAM_CERTIFICATIONS_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: MyTeamMembers,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.myTeamMembers",
        path: MY_TEAM_MEMBERS_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: MyTeamCertificationProfile,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.certification",
        path: `${MY_TEAM_URL_FRAGMENT}/certifications/:certificationId/:certificationStatus(active|expired|in-progress)`
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: RedirectToCertificationProfileDefaultTab,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.certification",
        path: `${MY_TEAM_URL_FRAGMENT}/certifications/:certificationId`
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: MyTeamCertificationsByTeam,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.myTeamCertificationsByTeam",
        path: `${MY_TEAM_URL_FRAGMENT}/certifications-by-team/:certificationStatus(active|expired|in-progress)`
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: RedirectToCertificationsByTeamDefaultTab,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.myTeamCertificationsByTeam",
        path: `${MY_TEAM_URL_FRAGMENT}/certifications-by-team`
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: MyTeamPlaylists,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.myTeamPlaylists",
        path: `${MY_TEAM_URL_FRAGMENT}/playlists/:playlistStatus(completed|incomplete|all)`
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: RedirectToPlaylistsDefaultTab,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.myTeamPlaylists",
        path: `${MY_TEAM_URL_FRAGMENT}/playlists`
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: EditProfile,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.editProfile",
        path: `${PROFILE_URL_FRAGMENT}/edit`
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: UserProfile,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.userProfile",
        path: `${PROFILE_URL_FRAGMENT}/:userId`
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: MyProfile,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.myProfile",
        path: PROFILE_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: MyLearningTabs,
        pageTitleI18nKey: "learningCenter.pageTitles.myLearning",
        path: MYLEARNING_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(Route, {
        component: RedirectToMyLearning,
        exact: false,
        path: LEGACY_MYLEARNING_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.hubspotPlaylistsAdmin",
        path: HUBSPOT_PLAYLISTS_ADMIN_URL_FRAGMENT,
        children: /*#__PURE__*/_jsx(HubspotPlaylistsAdmin, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: MY_PLAYLISTS_URL_FRAGMENT,
        children: /*#__PURE__*/_jsxs(Switch, {
          children: [/*#__PURE__*/_jsx(NavPageRoute, {
            exact: true,
            pageTitleI18nKey: "learningCenter.pageTitles.myPlaylists",
            path: MyPlaylistsRoutePaths,
            children: /*#__PURE__*/_jsx(MyPlaylists, {})
          }), /*#__PURE__*/_jsx(NavPageRoute, {
            component: Playlist,
            exact: true,
            pageTitleI18nKey: "learningCenter.pageTitles.playlist",
            path: [PLAYLIST_URL_FRAGMENT, PLAYLIST_RESULTS_URL_FRAGMENT, PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT],
            shouldRenderCenteredContent: false
          })]
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: SAVED_ITEMS_URL_FRAGMENT,
        children: /*#__PURE__*/_jsx(Switch, {
          children: /*#__PURE__*/_jsx(NavPageRoute, {
            component: RedirectToWatchLater,
            pageTitleI18nKey: "learningCenter.pageTitles.watchLater",
            path: LegacyWatchLaterRoutePaths
          })
        })
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: WatchLater,
        pageTitleI18nKey: "learningCenter.pageTitles.watchLater",
        path: WATCH_LATER_URL_FRAGMENT
      }), enviro.isQa() && /*#__PURE__*/_jsx(Route, {
        component: QaOnlyRoutes,
        path: "/qa-only"
      }), /*#__PURE__*/_jsx(Route, {
        component: RedirectToTracksWithQueryParams,
        path: "/tracks"
      }), /*#__PURE__*/_jsx(Route, {
        path: SHORT_URL_FRAGMENT,
        children: /*#__PURE__*/_jsx(ShortContentRoute, {})
      }), /*#__PURE__*/_jsx(Route, {
        component: RedirectToAward,
        exact: true,
        path: LEGACY_AWARD_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: TrackAwardModalContainer,
        exact: true,
        pageTitleI18nKey: "learningCenter.pageTitles.award",
        path: AWARD_URL_FRAGMENT
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: NotFound,
        pageTitleI18nKey: "learningCenter.pageTitles.notFound",
        path: "*"
      })]
    }), /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        component: RedirectToAward,
        path: `(.+)${LEGACY_AWARD_URL_FRAGMENT}`
      }), /*#__PURE__*/_jsx(NavPageRoute, {
        component: TrackAwardModalContainer,
        pageTitleI18nKey: "learningCenter.pageTitles.award",
        path: `(.+)${AWARD_URL_FRAGMENT}`
      })]
    }), /*#__PURE__*/_jsx(NavPageRoute, {
      component: AchievementPreviewModal,
      pageTitleI18nKey: "learningCenter.pageTitles.shareAwardPreview",
      path: SHARE_AWARD_PREVIEW_URL_FRAGMENT
    }), /*#__PURE__*/_jsx(Route, {
      component: EngagementTracking,
      path: `/tracks/:trackId(\\d+)`
    }), /*#__PURE__*/_jsx(Route, {
      component: EngagementTracking,
      path: `/lessons/:lessonId(\\d+)`
    }), /*#__PURE__*/_jsx(ModalRoute, {
      component: AssignPlaylist,
      pageTitleI18nKey: "learningCenter.pageTitles.assignPlaylist",
      path: `(.*)${ASSIGN_PLAYLIST_URL_FRAGMENT}`
    }), /*#__PURE__*/_jsx(Route, {
      component: ReactRouterSmoothScrollToTop,
      path: TRACKS_URL_FRAGMENT
    }), /*#__PURE__*/_jsx(Route, {
      component: ReactRouterSmoothScrollToTop,
      path: LESSONS_URL_FRAGMENT
    }), /*#__PURE__*/_jsx(Route, {
      component: ReactRouterSmoothScrollToTop,
      path: SHORT_URL_FRAGMENT
    }), /*#__PURE__*/_jsx(Route, {
      component: ReactRouterScrollToTop,
      path: MY_TEAM_URL_FRAGMENT
    })]
  });
};
export default Routes;